import { Loader } from "../../../components/loader";
import { Amount } from "../../../components/widget/text-widget";
import { useFetchable } from "../../../store/common/fetchable";
import { Crypto } from "../../../store/crypto/reducer";
import { BlockchainToolsRoutes } from "../../blockchain-tools/routes";
import { StyledTextWidget } from "./common";

export const FraudReportsSubmittedTile = () => {
  const fraudReportSummaryFetchable = useFetchable(Crypto.fraudReportSummary);

  return (
    <Loader data={[fraudReportSummaryFetchable]}>
      {([fraudReportSummary]) => (
        <StyledTextWidget
          title="Fraud Reports Submitted:"
          to={BlockchainToolsRoutes.names.reportAll}
        >
          <Amount>{fraudReportSummary.totalFromBeginningOfTime}</Amount> reports
        </StyledTextWidget>
      )}
    </Loader>
  );
};
